import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { lightSkeletonTheme, darkSkeletonTheme } from "./skeletonTheme";

// Mirrors Faq.jsx: a dark diagonal-clip hero (title + intro paragraph),
// then a numbered-row placeholder list matching the real accordion.
const FaqSkeleton = ({ navHeight }) => {
  return (
    <div
      className="w-full bg-[rgba(250,248,251,0.88)]"
      style={{ minHeight: navHeight ? `calc(100vh - ${navHeight}px)` : undefined }}
    >
      <div
        className="relative overflow-hidden bg-primary-dark px-6 pt-14 pb-16 md:px-12 md:pt-16 md:pb-20"
        style={{ clipPath: "polygon(0 0, 100% 0, 100% 92%, 50% 100%, 0 92%)" }}
      >
        <div className="relative max-w-3xl mx-auto">
          <SkeletonTheme {...darkSkeletonTheme}>
            <Skeleton height={40} width="60%" containerClassName="block mb-4" />
            <Skeleton count={2} height={16} containerClassName="block" />
          </SkeletonTheme>
        </div>
      </div>

      <div className="outer-container container">
        <div className="max-w-3xl mx-auto px-6 py-8 sm:py-12">
          <SkeletonTheme {...lightSkeletonTheme}>
            {Array.from({ length: 6 }).map((_, idx) => (
              <div
                key={idx}
                className="flex items-center gap-7 border-b border-primary-dark/10 last:border-b-0 py-6"
              >
                <Skeleton width={36} height={28} />
                <Skeleton width="60%" height={18} containerClassName="flex-1" />
                <Skeleton width={16} height={16} />
              </div>
            ))}
          </SkeletonTheme>
        </div>
      </div>
    </div>
  );
};

export default FaqSkeleton;
